module.exports = __webpack_public_path__ + "img/user.ee280cb6.svg";